import { render, staticRenderFns } from "./recommendation.vue?vue&type=template&id=7b21d351&scoped=true&"
import script from "./recommendation.vue?vue&type=script&lang=js&"
export * from "./recommendation.vue?vue&type=script&lang=js&"
import style0 from "./recommendation.vue?vue&type=style&index=0&id=7b21d351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21d351",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b21d351')) {
      api.createRecord('7b21d351', component.options)
    } else {
      api.reload('7b21d351', component.options)
    }
    module.hot.accept("./recommendation.vue?vue&type=template&id=7b21d351&scoped=true&", function () {
      api.rerender('7b21d351', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/components/recommendation.vue"
export default component.exports